import {isDeepEqual} from 'src/utils/isDeepEqual';

import type {CallCost} from 'src/openapi/admin/models/CallCost';
import type {CallCostGroup} from 'src/openapi/admin/models/CallCostGroup';

export const isDefaultCallCosts = (callGroups: CallCostGroup[], defaultCallCosts: CallCost[]) => {
    const callCosts = callGroups
        .reduce((acc, curr) => [...acc, ...curr.callCoasts], [] as CallCost[]);

    return isDeepEqual({prev: callCosts, current: defaultCallCosts});
};
